var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "container-scroller" },
    [
      _c("vue-progress-bar"),
      _vm._v(" "),
      _c("dashboard-navbar"),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "container-fluid page-body-wrapper" },
        [
          _c("dashboard-sidebar"),
          _vm._v(" "),
          _c("div", { staticClass: "main-panel" }, [
            _vm.$store.getters.isAuthenticated
              ? _c(
                  "div",
                  { staticClass: "content-wrapper vld-parent" },
                  [
                    _c("loading-indicator", {
                      attrs: {
                        sync: _vm.$store.getters.shouldLoadContent,
                        "full-page": false
                      }
                    }),
                    _vm._v(" "),
                    _vm.$route.name !== "start-subscription" &&
                    _vm.$route.name !== "subscription" &&
                    _vm.$route.name.substr(0, 5) !== "admin" &&
                    !_vm.$store.getters.isSubscribed
                      ? _c(
                          "div",
                          { staticClass: "alert alert-info shadow-sm" },
                          [
                            _c("h3", { staticClass: "title" }, [
                              _vm._v(
                                "\n                        " +
                                  _vm._s(
                                    _vm.$t("messages.not_subscribed.title")
                                  ) +
                                  "\n                    "
                              )
                            ]),
                            _vm._v(" "),
                            _c("p", [
                              _vm._v(
                                "\n                        " +
                                  _vm._s(
                                    _vm.$t("messages.not_subscribed.message")
                                  ) +
                                  "\n                    "
                              )
                            ]),
                            _vm._v(" "),
                            _c(
                              "router-link",
                              {
                                staticClass: "btn btn-outline-dark",
                                attrs: {
                                  to: { name: "start-subscription" },
                                  tag: "button"
                                }
                              },
                              [
                                _vm._v(
                                  "\n                        " +
                                    _vm._s(
                                      _vm.$t(
                                        "messages.not_subscribed.subscribe_now_link"
                                      )
                                    ) +
                                    "\n                    "
                                )
                              ]
                            )
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.$store.getters.isSubscribed
                      ? _c("livestream-alert")
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "transition",
                      { attrs: { name: "component-fade", mode: "out-in" } },
                      [_c("router-view")],
                      1
                    ),
                    _vm._v(" "),
                    _c("dashboard-footer")
                  ],
                  1
                )
              : _vm._e()
          ])
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }